// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"b9cce843","970":"f0456d66"}[chunkId] + ".chunk.css";
};